



















import { Component, Vue } from "vue-property-decorator";
import LetterTemplateList from "@/components/LetterTemplates/LetterTemplateList.vue";
import MonthlyReportList from "@/components/MonthlyReports/MonthlyReportList.vue";
import userStore from "@/store/userStore";
import { reaction } from "mobx";

@Component({ components: { LetterTemplateList, MonthlyReportList } })
export default class Admin extends Vue {
  dispose?: () => void;
  showMonthlyReport: boolean | undefined = !userStore.councilConfiguration?.hideMonthlyReport;
  mounted() {
    this.dispose = reaction(
      () => userStore.councilConfiguration,
      councilConfiguration => {
        this.showMonthlyReport = !councilConfiguration?.hideMonthlyReport;
      },
      { fireImmediately: true }
    );
  }

  destroyed() {
    if (this.dispose) this.dispose();
  }
}
